<template>
  <Teleport to="body">
    <Transition name="dialog-fade">
      <div v-if="modelValue" class="error-dialog-overlay" @click="handleClose">
        <div class="error-dialog" @click.stop>
          <div class="error-dialog-header">
            <i class="bi bi-exclamation-triangle-fill"></i>
            <h4>{{ title || $t('common.error_dialog.default_title') }}</h4>
          </div>
          <div class="error-dialog-body">
            {{ message }}
          </div>
          <div class="error-dialog-footer">
            <button class="btn-ok" @click="handleClose">
              {{ confirmText || $t('common.error_dialog.ok') }}
            </button>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup>
import { useI18n } from 'vue-i18n';

const { t: $t } = useI18n();

const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true
  },
  title: {
    type: String,
    default: ''
  },
  message: {
    type: String,
    required: true
  },
  confirmText: {
    type: String,
    default: ''
  }
});

const emit = defineEmits(['update:modelValue', 'confirm']);

const handleClose = () => {
  emit('update:modelValue', false);
  emit('confirm');
};
</script>

<style lang="scss" scoped>
.error-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10001;
}

.error-dialog {
  background: #FFFFFF;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  max-width: 400px;
  width: 90%;
  overflow: hidden;
}

.error-dialog-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 20px 24px;
  border-bottom: 1px solid #E5E7EB;

  i {
    font-size: 24px;
    color: #EF4444;
  }

  h4 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: #222222;
  }
}

.error-dialog-body {
  padding: 24px;
  font-size: 14px;
  color: #6B7280;
  line-height: 1.6;
}

.error-dialog-footer {
  padding: 16px 24px;
  border-top: 1px solid #E5E7EB;
  display: flex;
  justify-content: flex-end;

  .btn-ok {
    padding: 8px 24px;
    background: #306FC9;
    color: #FFFFFF;
    border: none;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      background-color: #F2F5F7;
      color: #306FC9;
    }

    &:active {
      transform: scale(0.98);
    }
  }
}

// Transition animations
.dialog-fade-enter-active,
.dialog-fade-leave-active {
  transition: opacity 0.2s ease;
}

.dialog-fade-enter-from,
.dialog-fade-leave-to {
  opacity: 0;
}

.dialog-fade-enter-active .error-dialog,
.dialog-fade-leave-active .error-dialog {
  transition: transform 0.2s ease;
}

.dialog-fade-enter-from .error-dialog,
.dialog-fade-leave-to .error-dialog {
  transform: scale(0.95);
}
</style>
